import ForgotPassword from './ForgotPassword';
import Login from './Login';
import RecoverPassword from './RecoverPassword';

export default {
  ForgotPassword,
  Login,
  RecoverPassword,
};
